import { Dispatch, GetState } from "common/types/redux";

import { analyticsLogCreateClass } from "seneca-common/features/class/analytics";
import { createAndReceiveClass } from "seneca-common/features/class/service";

export function createClass(className: string) {
  return async function (dispatch: Dispatch, getState: GetState) {
    try {
      const newClass = await dispatch(createAndReceiveClass(className));
      dispatch(analyticsLogCreateClass(newClass.classId));
      return newClass;
    } catch (err: any) {
      return err;
    }
  };
}
